import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, Fragment as _Fragment, renderList as _renderList, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "page-inner" }
const _hoisted_2 = { class: "stat-inner" }
const _hoisted_3 = { class: "stat-icon stat-icon-blue" }
const _hoisted_4 = { class: "stat-info" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "stat-label" }, "我的余额", -1)
const _hoisted_6 = { class: "stat-value" }
const _hoisted_7 = { class: "stat-actions" }
const _hoisted_8 = { class: "stat-inner" }
const _hoisted_9 = { class: "stat-icon stat-icon-green" }
const _hoisted_10 = { class: "stat-info" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "stat-label" }, "用户编号", -1)
const _hoisted_12 = { class: "stat-value stat-value-sm" }
const _hoisted_13 = { class: "stat-inner" }
const _hoisted_14 = { class: "stat-icon stat-icon-orange" }
const _hoisted_15 = { class: "stat-info" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "stat-label" }, "当前等级", -1)
const _hoisted_17 = { class: "stat-value stat-value-sm" }
const _hoisted_18 = { class: "stat-inner" }
const _hoisted_19 = { class: "stat-icon stat-icon-purple" }
const _hoisted_20 = { class: "stat-info" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "stat-label" }, "上级代理", -1)
const _hoisted_22 = { class: "stat-value stat-value-sm" }
const _hoisted_23 = { class: "qr-upload-item" }
const _hoisted_24 = { class: "qr-label" }
const _hoisted_25 = {
  key: 1,
  class: "qr-placeholder"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", null, "上传微信码", -1)
const _hoisted_27 = { class: "qr-upload-item" }
const _hoisted_28 = { class: "qr-label" }
const _hoisted_29 = {
  key: 1,
  class: "qr-placeholder"
}
const _hoisted_30 = /*#__PURE__*/_createElementVNode("span", null, "上传支付宝码", -1)
const _hoisted_31 = { class: "card-title-row" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("span", { class: "card-title-text" }, "我的授权列表", -1)
const _hoisted_33 = {
  key: 0,
  class: "plugin-cell"
}
const _hoisted_34 = { class: "plugin-name" }
const _hoisted_35 = { class: "plugin-sub" }
const _hoisted_36 = {
  key: 0,
  class: "auth-card-list"
}
const _hoisted_37 = { class: "mobile-card-head" }
const _hoisted_38 = { class: "mobile-card-title" }
const _hoisted_39 = { class: "mobile-card-body" }
const _hoisted_40 = { class: "mobile-field" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("span", { class: "mobile-label" }, "插件ID", -1)
const _hoisted_42 = { class: "mobile-value" }
const _hoisted_43 = { class: "mobile-field" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("span", { class: "mobile-label" }, "授权字段", -1)
const _hoisted_45 = { class: "mobile-field" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("span", { class: "mobile-label" }, "到期时间", -1)
const _hoisted_47 = { class: "mobile-value" }
const _hoisted_48 = { class: "mobile-field" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("span", { class: "mobile-label" }, "修改次数", -1)
const _hoisted_50 = { class: "mobile-field" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("span", { class: "mobile-label" }, "备注", -1)
const _hoisted_52 = { class: "mobile-card-foot" }
const _hoisted_53 = { class: "table-pagination" }
const _hoisted_54 = { class: "host-old" }
const _hoisted_55 = { class: "host-new" }
const _hoisted_56 = {
  key: 0,
  class: "unit-text",
  style: {"margin-left":"8px"}
}
const _hoisted_57 = { style: {"color":"#ff4d4f"} }

import UserHead from '@/components/UserHead.vue';
import HeadTop from '@/components/UserHeadTop.vue';
import { ref, onMounted, reactive, computed, getCurrentInstance } from 'vue';
import { isNull, getEmpower, EmpowerResponse } from '@/utils/publicMethods';
import { openLoading, fullscreenLoading } from '@/utils/loadingUtils'
import axios from 'axios';
import { message, Modal } from 'ant-design-vue'
import { Grade } from '@/types/gradeInterface'
import { useStore } from 'vuex';
import { useRouter } from 'vue-router'
import { PlusOutlined, QuestionCircleOutlined, InfoCircleOutlined, WalletOutlined, UserOutlined, CrownOutlined, TeamOutlined, WechatOutlined, AlipayCircleOutlined, AppstoreOutlined, GlobalOutlined, EditOutlined, HistoryOutlined, ClockCircleOutlined, WarningOutlined, CloseCircleOutlined, ReloadOutlined, DownOutlined, DeleteOutlined } from '@ant-design/icons-vue';

// 全局注册的图标（QuestionFilled 已全局注册）
interface grade_dataIn {
  grade_id: number,
  name: string,
  content: string,
  sell_price: number,
  higher_reward: number,
  isPoss: boolean,
  price_diff: number,
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ConsoleView',
  setup(__props) {

const QuestionFilled = QuestionCircleOutlined;
const InfoFilled = InfoCircleOutlined;

const baseURL = process.env.VUE_APP_API_BASE_URL;

var labelPosition = 'right'
var user_conf = ref({
  uid: '',
  username: '',
  user_email: '',
  higher_uid: "",
  password: "",
  money: "",
  higher_email: "",
  grade_id: -1,
  grade_name: "",
  grade_content: "",
  sell_price: 0,
  wxQR_code: '',
  zfbQR_code: ''
})
var appConf = ref({
  isRenew: false,
  empower_id: -1,
})
var balanceRechargeDialog = ref({
  isShow: false,
  money: "",
  types: [],
  type: "",
  checkType: { min: 0, max: 0 }
})
var deleteAuth_id = -1;
const getTimePrice = computed(() => {
  const product = time_meal_data.value.price * time_meal_data.value.num;
  return product.toFixed(2);
})

var grade_data = reactive<Grade[]>([]);

const select_option = ref()
var empower_data = ref([
  {
    includes_name: '',
    id: "",
    includes_id: "",
    add_date: '',
    empower_host: '',
    higher_uid: "",
    end_date: ""
  },
])
var updateHost_data = ref({
  empower_id: -1,
  update_host: ""
})
var setRemark_data = ref({
  empower_id: -1,
  remark: ""
})
var centerDialog = ref({
  isShow: false,
  title: "info",
  content: "content",
  clickBind: ""
})
var historyDialog = ref({
  isShow: false,
  title: "修改历史记录",
  list: [] as any[]
})
var trendsDialog = ref({
  dialogTitle: "",
  dialogVisible: false
})
var addEmpower_dialog = ref({
  dialogTitle: "",
  dialogVisible: false,
  select_option: "",
  time_Option: [],
  user_email: "",
  host: ""
})
var includes_data = ref({
  select_option: "",
  includes_list: [{
    id: "",
    grade_name: "",
    name: "",
    platform: ""
  }
  ]
})
var grade_Option = ref<grade_dataIn[]>([]);
const validateUsername = (rule: any, value: any, callback: any) => {
  const regExp = /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]+/;
  if (regExp.test(value)) {
    callback(new Error('不能有特殊字符'));
  } else {
    callback();
  }
}
const rules = {
  password: [
    { min: 6, max: 20, message: '长度在6-20位', trigger: ['change', 'blur'] },
  ],
  username: [
    { min: 1, max: 10, message: '长度在1-10位', trigger: ['change', 'blur'] },
    { validator: validateUsername, trigger: ['blur', 'change'] },
  ]
}
const userInfo_form = ref(null)
const openDialog = (title: string, content: string, isShow: boolean, clickBind: string) => {
  if (isShow == false) {
    centerDialog.value.isShow = false
  }
  else {
    centerDialog.value.title = title
    centerDialog.value.content = content
    centerDialog.value.isShow = true
    centerDialog.value.clickBind = clickBind
  }
}
const centerDialogClick = (act: string) => {
  switch (act) {
    case "setUserInfo":
      submitForm('setUserInfo');
      break;
    case 'updateHost':
      submitForm('updateHost');
      break;
    case 'setRemark':
      submitForm('setRemark');
      break;
    case 'gradeUp':
      submitForm('gradeUp');
      break;
    case 'addEmpower':
      addEmpowerFun('post');
      break;
    case 'renewEmpower':
      renewEmpowerFun();
      break;
    case 'deleteAuth':
      deleteAuth(deleteAuth_id)
      break;
    default:
      break;
  }
}
const cacheOrigin = (record: any, field: string) => {
  const key = `${field}_origin`
  if (!(key in record)) {
    record[key] = record[field === 'host' ? 'empower_host' : 'remark'] ?? ''
  }
}
const updateHostClick = (record: any) => {
  const origin = record.host_origin ?? ''
  const current = record.empower_host ?? ''
  if (current === origin) return
  record.host_origin = current
  updateHost_data.value.empower_id = record.empower_id
  updateHost_data.value.update_host = current
  openDialog('消息', '您确认要修改此授权吗', true, 'updateHost')
}
const updateRemarkClick = (record: any) => {
  const origin = record.remark_origin ?? ''
  const current = record.remark ?? ''
  if (current === origin) return
  record.remark_origin = current
  setRemark_data.value.empower_id = record.empower_id
  setRemark_data.value.remark = current
  openDialog('消息', '您确认要修改此备注吗', true, 'setRemark')
}
const parseHistory = (historyStr: string | null | undefined) => {
  if (!historyStr) return [];
  try {
    const arr = JSON.parse(historyStr);
    return Array.isArray(arr) ? arr : [];
  } catch {
    return [];
  }
}
const openHistoryDialog = (row: any) => {
  const includeName = row.includes_name ? row.includes_name + ' - ' : '';
  historyDialog.value.title = includeName + '修改历史记录';
  historyDialog.value.list = parseHistory(row.modify_history);
  historyDialog.value.isShow = true;
}
const renewAuthDialog = (empower_id: number, includes_id: string, version: number) => {
  appConf.value.isRenew = true;
  addEmpower_dialog.value.dialogVisible = true
  includes_data.value.select_option = includes_id;
  appConf.value.empower_id = empower_id;
  getTimeMeal(includes_id, version + "");

}
const renewEmpowerFun = () => {
  openLoading();
  centerDialog.value.isShow = false
  const headers = {
    'token': localStorage.getItem("token")
  }
  const data = {
    empower_id: appConf.value.empower_id
    , time_act: time_meal_data.value.meal_id
    , time_num: time_meal_data.value.num
  }
  axios.post(baseURL + "/userApi/renewSelfEmpower", data, { timeout: 10000, headers: headers })
    .then(async (res) => {
      fullscreenLoading.close()
      if (res.data.code == 200) {
        addEmpower_dialog.value.dialogVisible = false
        message.success(res.data.msg)
        getUserInfo();
      }
      else {
        message.error(res.data.msg)
      }
    })
    .catch(err => {
      fullscreenLoading.close()
      console.log(err)
      message.error('续费失败：' + err.message)
    })
}
const getUserInfo = () => {
  openLoading()
  const headers = {
    'token': localStorage.getItem("token")
  }
  axios.get(baseURL + "/userApi/getUserInfo", { timeout: 10000, headers: headers })
    .then(res => {
      fullscreenLoading.close()
      empowerLoading.value = false
      if (res.data.code == 200) {
        user_conf.value = res.data.data
        user_conf.value.higher_email = res.data.data.higher_email
        localStorage.setItem("user_conf", JSON.stringify(user_conf.value))
        empower_data.value = res.data.empower_data;
        empower_Conf.value.total = res.data.total_empower
        empower_Conf.value.disabled = res.data.total_empower < empower_Conf.value.pageSize
      }
      else {
        message.error(res.data.msg)
        if (res.data.code == 401) {
          message.error(res.data.msg)
          setTimeout(() => {
            location.href = "/Login"
          }, 500);
        }
      }
    })
    .catch(err => {
      fullscreenLoading.close()
      empowerLoading.value = false
      console.log(err)
      message.error('获取用户信息失败：' + err.message)
    })
}
const submitForm = (act: string) => {
  openLoading()
  centerDialog.value.isShow = false
  const data = new FormData();
  const headers = {
    'token': localStorage.getItem("token")
  }
  switch (act) {
    case "setUserInfo":
      if (!user_conf.value.username) {
        fullscreenLoading.close()
        message.error('请输入用户名')
        return
      }
      data.append("act", "setUserInfo");
      if (user_conf.value.password) {
        data.append("password", user_conf.value.password);
      }
      if (user_conf.value.username) {
        data.append("username", user_conf.value.username);
      }
      if (user_conf.value.user_email) {
        data.append("user_email", user_conf.value.user_email);
      }
      axios.post(baseURL + "/userApi/userSet", data, { timeout: 10000, headers: headers })
        .then(res => {
          fullscreenLoading.close()
          if (res.data.code == 401) {
            message.error('您没有登录')
            setTimeout(() => {
              location.href = "/Login"
            }, 1000);
          }
          else if (res.data.code == 200) {
            message.success(res.data.msg)
            getUserInfo();
          }
          else {
            message.error(res.data.msg)
          }
        })
        .catch(err => {
          fullscreenLoading.close()
          console.log(err)
          message.error('请求失败：' + err.message)
        })
      break;
    case "updateHost": {
      const sendUpdateHost = (paid: number) => {
        const hostData = new FormData();
        hostData.append("act", "updateHost");
        if (updateHost_data.value.empower_id && updateHost_data.value.empower_id != -1) {
          hostData.append("empower_id", String(updateHost_data.value.empower_id));
        }
        if (updateHost_data.value.update_host && updateHost_data.value.update_host != "") {
          hostData.append("update_host", updateHost_data.value.update_host);
        }
        if (paid == 1) {
          hostData.append("paid", "1");
        }
        axios.post(baseURL + "/userApi/userSet", hostData, { timeout: 10000, headers: headers })
          .then(res => {
            fullscreenLoading.close()
            if (res.data.code == 401) {
              message.error('您没有登录')
              setTimeout(() => {
                location.href = "/Login"
              }, 1000);
            }
            else if (res.data.code == 4031) {
              const paidPrice = res.data.data ? res.data.data.paid_price : '';
              Modal.confirm({
                title: '付费修改确认',
                content: '免费修改次数已用完，付费修改将扣除 ' + paidPrice + ' 元，是否继续？',
                okText: '确认付费',
                cancelText: '取消',
                okType: 'warning',
                onOk: () => {
                  openLoading()
                  sendUpdateHost(1)
                },
                onCancel: () => undefined
              })
            }
            else if (res.data.code == 200) {
              message.success(res.data.msg)
              getEmpower1();
            }
            else {
              message.error(res.data.msg)
            }
          })
          .catch(err => {
            fullscreenLoading.close()
            console.log(err)
            message.error('请求失败：' + err.message)
          })
      }
      sendUpdateHost(0);
      break;
    }
    case "setRemark": {
      openLoading();
      centerDialog.value.isShow = false
      const remarkPostData = {
        empower_id: setRemark_data.value.empower_id,
        remark: setRemark_data.value.remark
      }
      axios.post(baseURL + "/userApi/setRemark", remarkPostData, { timeout: 10000, headers: headers })
        .then(res => {
          fullscreenLoading.close()
          if (res.data.code == 401) {
            message.error('您没有登录')
            setTimeout(() => {
              location.href = "/Login"
            }, 1000);
          }
          else if (res.data.code == 200) {
            message.success(res.data.msg)
            getEmpower1();
          }
          else {
            message.error(res.data.msg)
          }
        })
        .catch(err => {
          fullscreenLoading.close()
          console.log(err)
          message.error('请求失败：' + err.message)
        })
      break;
    }
    case 'gradeUp':
      data.append("act", "gradeUp")
      data.append("grade_id", select_option.value)
      axios.post(baseURL + "/userApi/userSet", data, { timeout: 10000, headers: headers })
        .then(res => {
          fullscreenLoading.close()
          if (res.data.code == 401) {
            message.error('您没有登录')
            setTimeout(() => {
              location.href = "/Login"
            }, 1000);
          }
          else if (res.data.code == 200) {
            message.success(res.data.msg)
            getUserInfo();
          }
          else {
            message.error(res.data.msg)
          }
        })
        .catch(err => {
          fullscreenLoading.close()
          console.log(err)
          message.error('请求失败：' + err.message)
        })
      break;

    default:
      break;
  }
}
const puy_money = () => {
  balanceRechargeDialog.value.isShow = true;
  axios.get(baseURL + "/pay/payType", { timeout: 10000, headers: { 'token': localStorage.getItem("token") } })
    .then(res => {
      if (res.data.code == 200) {
        balanceRechargeDialog.value.types = res.data.data.list
      } else {
        message.error(res.data.msg)
      }
    }).catch(err => {
      console.log(err)
      message.error('请求失败：' + err.message)
    })

}

const payTypeChange = (value: any) => {
  for (let i = 0; i < balanceRechargeDialog.value.types.length; i++) {
    const item = balanceRechargeDialog.value.types[i];
    if (item.type == value) {
      value = item
      break;
    }
  }
  balanceRechargeDialog.value.checkType = value;
}
const store = useStore();
const router = useRouter();
const toRecharge = () => {
  const money = parseInt(balanceRechargeDialog.value.money);
  const min = balanceRechargeDialog.value.checkType.min;
  const max = balanceRechargeDialog.value.checkType.max;
  if (money < min || money > max) {
    message.error('充值金额超出范围：[' + min + ',' + max + ']');
    return;
  }
  openLoading()
  axios.post(baseURL + "/pay/balanceRecharge", {
    name: "余额充值",
    money: balanceRechargeDialog.value.money,
    type: balanceRechargeDialog.value.type
  }, { timeout: 10000, headers: { 'token': localStorage.getItem("token") } })
    .then(res => {
      fullscreenLoading.close()
      if (res.data.code == 200) {
        balanceRechargeDialog.value.isShow = false;
        const url = res.data.data.url;
        if (!isNull(url)) {
          window.open(res.data.data.url, '_blank');
        } else {
          const outTradeNo = res.data.data.outTradeNo;
          sessionStorage.setItem("outTradeNo", outTradeNo);
          window.open("/alipayDMF", '_blank');
        }
      } else {
        message.error(res.data.msg)
      }
    }).catch(err => {
      fullscreenLoading.close()
      console.log(err)
      message.error('请求失败：' + err.message)
    })
}
const withdrawalView = () => {
  location.href = '/Withdrawal'
}
const handleExceed = (files: any, uploadFiles: any) => {
  message.warning(
    `限制上传一个, 你选择了${files.length} 个文件,`
  )
}
const upload = ref({
  url: baseURL + "/xiaochuFile/uploadImg",
  wx_data: { 'act': 'uploadWxQR', 'token': localStorage.getItem('token') },
  zfb_data: { 'act': 'uploadZfbQR', 'token': localStorage.getItem('token') },
  wx_code: "",
  zfb_code: '',
})
const beforeAvatarUpload = (rawFile: any) => {
  if (rawFile.type !== 'image/jpeg' && rawFile.type !== 'image/png' && rawFile.type !== 'image/gif' && rawFile.type !== 'image/jpg') {
    message.error('只能上传jpeg,png,gif,jp文件')
    return false
  } else if (rawFile.size / 1024 / 1024 > 2) {
    message.error('文件大小不能超过 2MB!')
    return false
  }
  return true
}
const handleWxUploadChange = (info: any) => {
  if (info.file.status === 'done') {
    handleSuccess(info.file.response)
  } else if (info.file.status === 'error') {
    message.error('上传失败')
  }
}
const handleZfbUploadChange = (info: any) => {
  if (info.file.status === 'done') {
    handleSuccess(info.file.response)
  } else if (info.file.status === 'error') {
    message.error('上传失败')
  }
}
const handleSuccess = (response: any) => {
  if (response.code == 200) {
    upload.value.wx_code = ""
    upload.value.zfb_code = ""
    message.success(response.msg)
    if (response.data.includes("zfb_qr")) {
      user_conf.value.zfbQR_code = response.data + "?t=" + Date.now()
    }
    else {
      user_conf.value.wxQR_code = response.data + "?t=" + Date.now()
    }
  }
  else {
    message.error(response.msg)
  }
}
const empower_Conf = ref({
  total: 0,
  pageSize: 10,
  currentPage: 1,
  disabled: false,
})
const empowerLoading = ref(true)
const sizeChange = (val: number) => {
  empower_Conf.value.pageSize = val
  getEmpower1()
}
const currentChange = (val: number) => {
  empower_Conf.value.currentPage = val
  getEmpower1()
}
const pageChange = (page: number, pageSize: number) => {
  empower_Conf.value.currentPage = page
  empower_Conf.value.pageSize = pageSize
  getEmpower1()
}
const getEmpower1 = async () => {
  empowerLoading.value = true
  try {
    const res: EmpowerResponse = await getEmpower(empower_Conf.value.currentPage, empower_Conf.value.pageSize);
    if (res.code == 200) {
      empower_Conf.value.total = res.total_empower
      empower_Conf.value.disabled = res.data.total_empower < empower_Conf.value.pageSize
      empower_data.value = res.data
    }
  } finally {
    empowerLoading.value = false
  }
}
const addEmpowerFun = (act: string) => {
  if (act == 'dialog') {
    appConf.value.isRenew = false;
    addEmpower_dialog.value.dialogVisible = true;
    time_meal_data.value.time_meal_list = [];
    version_data.value.version_list = [];
    version_data.value.select_option = "";

    openLoading();
    const headers = {
      'token': localStorage.getItem("token") || ''
    };

    axios.get(baseURL + "/userApi/getIncludesAll", { timeout: 10000, headers: headers })
      .then(res => {
        fullscreenLoading.close();
        if (res.data.code == 200) {
          includes_data.value.includes_list = res.data.data;
        } else {
          message.error(res.data.msg);
        }
      })
      .catch(err => {
        fullscreenLoading.close();
        console.log(err);
        message.error('获取插件列表失败：' + err.message);
      });
  } else if (act == 'post') {
    openLoading();
    centerDialog.value.isShow = false;
    const headers = {
      'token': localStorage.getItem("token") || ''
    };

    const data = new FormData();
    data.append("includes_id", includes_data.value.select_option);
    data.append("host", addEmpower_dialog.value.host);
    data.append("email", addEmpower_dialog.value.user_email);
    data.append("time_act", time_meal_data.value.meal_id + "");
    data.append("time_num", time_meal_data.value.num + "");

    // Add version if selected
    if (version_data.value.select_option) {
      data.append("version", version_data.value.select_option);
    }

    axios.post(baseURL + "/userApi/addSelfEmpower", data, { timeout: 10000, headers: headers })
      .then(res => {
        fullscreenLoading.close();
        if (res.data.code == 200) {
          addEmpower_dialog.value.dialogVisible = false;
          message.success(res.data.msg);
          getUserInfo(); // Refresh user info after successful authorization
        } else {
          message.error(res.data.msg);
        }
      })
      .catch(err => {
        fullscreenLoading.close();
        console.log(err);
        message.error('添加授权失败：' + err.message);
      });
  }
}

var time_meal_data = ref({
  select_option: "",
  time_meal_list: [
    {
      meal_id: "",
      min: 1,
      max: 1,
      price: 0,
      time_unit: "",
    }
  ],
  num: 1,
  min: 1,
  max: 1,
  unit: "",
  price: 1,
  meal_id: ""
})
var version_data = ref({
  select_option: "",
  version_list: [] as { version: string; versionName: string }[]
})

// Add method to get plugin versions
const getPluginVersions = (soft_id: string) => {
  // Reset version selection and time meal data
  version_data.value.select_option = "";
  version_data.value.version_list = [];
  time_meal_data.value.select_option = "";
  time_meal_data.value.time_meal_list = [];

  // If no plugin selected, return
  if (!soft_id) return;

  openLoading();
  const headers = {
    'token': localStorage.getItem("token") || ''
  };

  const data = {
    soft_id: soft_id
  };

  axios.post(baseURL + "/userApi/getSoftVersion", data, { timeout: 10000, headers: headers })
    .then(res => {
      fullscreenLoading.close();
      if (res.data.code == 200) {
        version_data.value.version_list = res.data.data.list || [];
        // If there's only one version, auto-select it
        if (res.data.data.list && res.data.data.list.length === 1) {
          version_data.value.select_option = res.data.data.list[0].version;
          onVersionChange(res.data.data.list[0].version);
        }
      } else {
        message.error(res.data.msg || '获取版本信息失败');
      }
    })
    .catch(err => {
      fullscreenLoading.close();
      console.log(err);
      message.error('获取版本信息失败：' + err.message);
    });
}

// Add method to handle version change
const onVersionChange = (version: string) => {
  // Reset time meal selection
  time_meal_data.value.select_option = "";
  time_meal_data.value.time_meal_list = [];

  if (version && includes_data.value.select_option) {
    getTimeMeal(includes_data.value.select_option, version);
  }
}
const getTimeMeal = (includes_id: string, version?: string) => {
  openLoading();
  const data = new FormData();
  const headers = {
    'token': localStorage.getItem("token") || ''
  };

  data.append("includes_id", includes_id);
  data.append("act", "getTimeMeal");

  // Add version if provided
  if (version) {
    data.append("version", version);
  }

  axios.post(baseURL + "/userApi/getInfo", data, { timeout: 10000, headers: headers })
    .then(res => {
      fullscreenLoading.close();
      if (res.data.code == 401) {
        message.error('您没有登录');
        setTimeout(() => {
          location.href = "/Login";
        }, 1000);
      } else if (res.data.code == 200) {
        time_meal_data.value.time_meal_list = res.data.data;
      } else {
        message.error(res.data.msg);
      }
    })
    .catch(err => {
      fullscreenLoading.close();
      console.log(err);
      message.error('请求失败：' + err.message);
    });
}
const deleteAuthDialog = (empower_id: number) => {
  deleteAuth_id = empower_id
  openDialog('消息', '您确定要删除此授权吗？此操作不可撤销', true, 'deleteAuth')
}
const deleteAuth = (empower_id: number) => {
  openLoading()
  const data = new FormData();
  const headers = {
    'token': localStorage.getItem("token")
  }
  data.append("id", empower_id + "")
  axios.post(baseURL + "/userApi/deleteAuth", data, { timeout: 10000, headers: headers })
    .then(res => {
      fullscreenLoading.close()
      centerDialog.value.isShow = false
      if (res.data.code == 401) {
        message.error('您没有登录')
        setTimeout(() => {
          location.href = "/Login"
        }, 1000);
      }
      else if (res.data.code == 200) {
        message.success(res.data.msg);
        setTimeout(() => {
          getUserInfo()
        }, 200);
      }
      else {
        message.error(res.data.msg)
      }
    })
    .catch(err => {
      centerDialog.value.isShow = false
      fullscreenLoading.close()
      console.log(err)
      message.error('请求失败：' + err.message)
    })
}
const setTimeMeal = (select_option: string) => {
  var element = time_meal_data.value.time_meal_list.filter(item => item.meal_id == select_option);
  time_meal_data.value.num = 1
  time_meal_data.value.min = element[0].min
  time_meal_data.value.max = element[0].max
  time_meal_data.value.unit = element[0].time_unit
  time_meal_data.value.price = element[0].price
  time_meal_data.value.meal_id = element[0].meal_id
}
//计算结束时间还有多久
const getEndDateColor = (end_date: string) => {
  var endDate = new Date(end_date);
  if (endDate.getTime() < new Date().getTime()) {
    return 3;
  }
  if (endDate.getTime() < new Date().getTime() + 1000 * 60 * 60 * 24 * 3) {
    return 2;
  }
  return 1;
}

const getEndDateTagColor = (end_date: string) => {
  const c = getEndDateColor(end_date);
  if (c === 1) return 'green';
  if (c === 2) return 'gold';
  return 'red';
}

// 授权搜索条件
const empowerSearch = reactive({
  keyword: '',
  expireFilter: ''
});

// 行样式（过期行加背景）
const getEmpowerRowClass = (record: any) => {
  const c = getEndDateColor(record.end_date);
  if (c === 3) return 'row-expired';
  if (c === 2) return 'row-warning';
  return '';
};

// 重置搜索
const resetEmpowerSearch = () => {
  empowerSearch.keyword = '';
  empowerSearch.expireFilter = '';
  getEmpower(1);
};

// 前端过滤（如果后端不支持搜索）
const filteredEmpowerData = computed(() => {
  let data = empower_data.value;
  if (!data || data.length === 0) return data;
  if (empowerSearch.keyword) {
    const kw = empowerSearch.keyword.toLowerCase();
    data = data.filter((r: any) =>
      (r.includes_name || '').toLowerCase().includes(kw) ||
      (r.empower_host || '').toLowerCase().includes(kw) ||
      (r.remark || '').toLowerCase().includes(kw)
    );
  }
  if (empowerSearch.expireFilter) {
    data = data.filter((r: any) => {
      const c = getEndDateColor(r.end_date);
      if (empowerSearch.expireFilter === 'normal') return c === 1;
      if (empowerSearch.expireFilter === 'warning') return c === 2;
      if (empowerSearch.expireFilter === 'expired') return c === 3;
      return true;
    });
  }
  return data;
});

// 授权列表列配置
const empowerColumns = [
  { title: '插件信息', key: 'includes_name', width: 150 },
  { title: '插件ID', dataIndex: 'includes_id', key: 'includes_id', width: 70 },
  { title: '添加时间', dataIndex: 'add_date', key: 'add_date', width: 130 },
  { title: '授权字段', key: 'host', width: 180 },
  { title: '授权者ID', dataIndex: 'add_uid', key: 'add_uid', width: 70 },
  { title: '已免费修改', key: 'modify_count', width: 90, align: 'center' },
  { title: '修改历史', key: 'modify_history', width: 80, align: 'center' },
  { title: '到期时间', key: 'end_date', dataIndex: 'end_date', width: 130, align: 'center' },
  { title: '备注', key: 'remark', width: 140 },
  { title: '操作', key: 'action', width: 100, align: 'center' },
];

onMounted(async () => {
  const globalProperties = getCurrentInstance().appContext.config.globalProperties;
  window.ResizeObserver = globalProperties.$customResizeObserver;
  await getUserInfo()
})

return (_ctx: any,_cache: any) => {
  const _component_a_layout_header = _resolveComponent("a-layout-header")!
  const _component_a_statistic = _resolveComponent("a-statistic")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input_password = _resolveComponent("a-input-password")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_image = _resolveComponent("a-image")!
  const _component_a_upload = _resolveComponent("a-upload")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_dropdown = _resolveComponent("a-dropdown")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_empty = _resolveComponent("a-empty")!
  const _component_a_pagination = _resolveComponent("a-pagination")!
  const _component_a_layout_content = _resolveComponent("a-layout-content")!
  const _component_a_layout = _resolveComponent("a-layout")!
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_a_table_column = _resolveComponent("a-table-column")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_input_number = _resolveComponent("a-input-number")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_layout, { style: {"min-height":"100vh"} }, {
      default: _withCtx(() => [
        _createVNode(UserHead),
        _createVNode(_component_a_layout, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_layout_header, { style: {"padding":"0","background":"#fff","border-bottom":"1px solid #f0f0f0"} }, {
              default: _withCtx(() => [
                _createVNode(HeadTop)
              ]),
              _: 1
            }),
            _createVNode(_component_a_layout_content, {
              class: "page-content",
              style: {"padding":"24px","background":"#f5f7fa"}
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  _createVNode(_component_a_row, {
                    gutter: [16, 16],
                    class: "stat-row"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, {
                        xs: 24,
                        sm: 12,
                        md: 6
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_card, {
                            class: "stat-card stat-card-primary",
                            bordered: false
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_2, [
                                _createElementVNode("div", _hoisted_3, [
                                  _createVNode(_unref(WalletOutlined))
                                ]),
                                _createElementVNode("div", _hoisted_4, [
                                  _hoisted_5,
                                  _createElementVNode("div", _hoisted_6, [
                                    _createVNode(_component_a_statistic, {
                                      value: _unref(user_conf).money,
                                      precision: 2,
                                      prefix: "¥"
                                    }, null, 8, ["value"])
                                  ]),
                                  _createElementVNode("div", _hoisted_7, [
                                    _createVNode(_component_a_button, {
                                      type: "link",
                                      size: "small",
                                      onClick: _cache[0] || (_cache[0] = ($event: any) => (puy_money()))
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("在线充值")
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_a_divider, { type: "vertical" }),
                                    _createVNode(_component_a_button, {
                                      type: "link",
                                      size: "small",
                                      onClick: _cache[1] || (_cache[1] = ($event: any) => (withdrawalView()))
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("提现")
                                      ]),
                                      _: 1
                                    })
                                  ])
                                ])
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_col, {
                        xs: 24,
                        sm: 12,
                        md: 6
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_card, {
                            class: "stat-card",
                            bordered: false
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_8, [
                                _createElementVNode("div", _hoisted_9, [
                                  _createVNode(_unref(UserOutlined))
                                ]),
                                _createElementVNode("div", _hoisted_10, [
                                  _hoisted_11,
                                  _createElementVNode("div", _hoisted_12, _toDisplayString(_unref(user_conf).uid), 1)
                                ])
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_col, {
                        xs: 24,
                        sm: 12,
                        md: 6
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_card, {
                            class: "stat-card",
                            bordered: false
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_13, [
                                _createElementVNode("div", _hoisted_14, [
                                  _createVNode(_unref(CrownOutlined))
                                ]),
                                _createElementVNode("div", _hoisted_15, [
                                  _hoisted_16,
                                  _createElementVNode("div", _hoisted_17, _toDisplayString(_unref(user_conf).grade_name || '普通用户'), 1)
                                ])
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_col, {
                        xs: 24,
                        sm: 12,
                        md: 6
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_card, {
                            class: "stat-card",
                            bordered: false
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_18, [
                                _createElementVNode("div", _hoisted_19, [
                                  _createVNode(_unref(TeamOutlined))
                                ]),
                                _createElementVNode("div", _hoisted_20, [
                                  _hoisted_21,
                                  _createElementVNode("div", _hoisted_22, _toDisplayString(_unref(user_conf).higher_uid || '无'), 1)
                                ])
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_row, {
                    gutter: [16, 16],
                    class: "info-row"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, {
                        xs: 24,
                        lg: 14
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_card, {
                            title: "用户信息管理",
                            bordered: false,
                            class: "info-card"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_form, {
                                model: _unref(user_conf),
                                layout: "horizontal",
                                "label-col": { span: 5 },
                                "wrapper-col": { span: 14 }
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_form_item, { label: "用户编号" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_input, {
                                        value: _unref(user_conf).uid,
                                        disabled: ""
                                      }, null, 8, ["value"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_a_form_item, { label: "用户名" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_input, {
                                        value: _unref(user_conf).username,
                                        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_unref(user_conf).username) = $event)),
                                        placeholder: "请输入用户名"
                                      }, null, 8, ["value"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_a_form_item, { label: "我的上级" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_input, {
                                        value: _unref(user_conf).higher_uid,
                                        disabled: ""
                                      }, null, 8, ["value"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_a_form_item, { label: "绑定邮箱" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_input, {
                                        value: _unref(user_conf).user_email,
                                        disabled: ""
                                      }, null, 8, ["value"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_a_form_item, { label: "登录密码" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_input_password, {
                                        value: _unref(user_conf).password,
                                        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_unref(user_conf).password) = $event)),
                                        placeholder: "请输入新密码"
                                      }, null, 8, ["value"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_a_form_item, { "wrapper-col": { offset: 5, span: 14 } }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_button, {
                                        type: "primary",
                                        onClick: _cache[4] || (_cache[4] = ($event: any) => (openDialog('消息', '您确认要修改用户信息吗', true, 'setUserInfo')))
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(" 保存修改 ")
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["model"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_col, {
                        xs: 24,
                        lg: 10
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_card, {
                            title: "收款信息管理",
                            bordered: false,
                            class: "info-card"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_row, { gutter: [16, 16] }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_col, { span: 12 }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_23, [
                                        _createElementVNode("div", _hoisted_24, [
                                          _createVNode(_unref(WechatOutlined)),
                                          _createTextVNode(" 微信收款码 ")
                                        ]),
                                        _createVNode(_component_a_upload, {
                                          "show-upload-list": false,
                                          class: "qr-uploader",
                                          action: upload.value.url,
                                          data: upload.value.wx_data,
                                          "before-upload": beforeAvatarUpload,
                                          onChange: handleWxUploadChange
                                        }, {
                                          default: _withCtx(() => [
                                            (!_unref(isNull)(_unref(user_conf).wxQR_code))
                                              ? (_openBlock(), _createBlock(_component_a_image, {
                                                  key: 0,
                                                  src: _unref(user_conf).wxQR_code,
                                                  fit: "cover",
                                                  class: "qr-preview"
                                                }, null, 8, ["src"]))
                                              : (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                                  _createVNode(_unref(PlusOutlined), { class: "qr-plus" }),
                                                  _hoisted_26
                                                ]))
                                          ]),
                                          _: 1
                                        }, 8, ["action", "data"])
                                      ])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_a_col, { span: 12 }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_27, [
                                        _createElementVNode("div", _hoisted_28, [
                                          _createVNode(_unref(AlipayCircleOutlined)),
                                          _createTextVNode(" 支付宝收款码 ")
                                        ]),
                                        _createVNode(_component_a_upload, {
                                          "show-upload-list": false,
                                          class: "qr-uploader",
                                          action: upload.value.url,
                                          data: upload.value.zfb_data,
                                          "before-upload": beforeAvatarUpload,
                                          onChange: handleZfbUploadChange
                                        }, {
                                          default: _withCtx(() => [
                                            (!_unref(isNull)(_unref(user_conf).zfbQR_code))
                                              ? (_openBlock(), _createBlock(_component_a_image, {
                                                  key: 0,
                                                  src: _unref(user_conf).zfbQR_code,
                                                  fit: "cover",
                                                  class: "qr-preview"
                                                }, null, 8, ["src"]))
                                              : (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                                  _createVNode(_unref(PlusOutlined), { class: "qr-plus" }),
                                                  _hoisted_30
                                                ]))
                                          ]),
                                          _: 1
                                        }, 8, ["action", "data"])
                                      ])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_card, {
                    bordered: false,
                    class: "table-card"
                  }, {
                    title: _withCtx(() => [
                      _createElementVNode("div", _hoisted_31, [
                        _hoisted_32,
                        _createVNode(_component_a_tag, { color: "blue" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(empower_Conf.value.total) + " 条", 1)
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    extra: _withCtx(() => [
                      _createVNode(_component_a_button, {
                        type: "primary",
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (addEmpowerFun('dialog')))
                      }, {
                        icon: _withCtx(() => [
                          _createVNode(_unref(PlusOutlined))
                        ]),
                        default: _withCtx(() => [
                          _createTextVNode("添加授权 ")
                        ]),
                        _: 1
                      })
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_a_table, {
                        class: "auth-table-pc",
                        "data-source": _unref(empower_data),
                        pagination: false,
                        "row-key": "empower_id",
                        scroll: { x: 1140 },
                        size: "small",
                        loading: empowerLoading.value,
                        bordered: "",
                        columns: empowerColumns,
                        "row-class-name": getEmpowerRowClass
                      }, {
                        bodyCell: _withCtx(({ column, record }) => [
                          (column.key === 'includes_name')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                _createElementVNode("div", _hoisted_34, [
                                  _createVNode(_unref(AppstoreOutlined), { class: "plugin-icon" }),
                                  _createTextVNode(" " + _toDisplayString(record.includes_name), 1)
                                ]),
                                _createElementVNode("div", _hoisted_35, [
                                  _createVNode(_component_a_tag, {
                                    color: "blue",
                                    style: {"margin":"0"}
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("v" + _toDisplayString(record.version_name), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ])
                              ]))
                            : (column.key === 'host')
                              ? (_openBlock(), _createBlock(_component_a_input, {
                                  key: 1,
                                  value: record.empower_host,
                                  "onUpdate:value": ($event: any) => ((record.empower_host) = $event),
                                  size: "small",
                                  onFocus: ($event: any) => (cacheOrigin(record, 'host')),
                                  onBlur: ($event: any) => (updateHostClick(record)),
                                  placeholder: "请输入域名/IP"
                                }, {
                                  addonBefore: _withCtx(() => [
                                    _createVNode(_unref(GlobalOutlined))
                                  ]),
                                  _: 2
                                }, 1032, ["value", "onUpdate:value", "onFocus", "onBlur"]))
                              : (column.key === 'modify_count')
                                ? (_openBlock(), _createBlock(_component_a_tooltip, {
                                    key: 2,
                                    placement: "top",
                                    title: "1.每月可免费修改授权次数有限，2.每个授权总共的免费修改次数有限，超出后可付费修改（从余额扣除）"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("span", {
                                        class: _normalizeClass(["modify-count", { 'modify-count-zero': !record.modify_count }])
                                      }, [
                                        _createVNode(_unref(EditOutlined), { class: "tip-icon" }),
                                        _createTextVNode(" " + _toDisplayString(record.modify_count || 0) + " 次 ", 1)
                                      ], 2)
                                    ]),
                                    _: 2
                                  }, 1024))
                                : (column.key === 'modify_history')
                                  ? (_openBlock(), _createBlock(_component_a_button, {
                                      key: 3,
                                      size: "small",
                                      type: "link",
                                      disabled: !record.modify_history,
                                      onClick: ($event: any) => (openHistoryDialog(record))
                                    }, {
                                      icon: _withCtx(() => [
                                        _createVNode(_unref(HistoryOutlined))
                                      ]),
                                      default: _withCtx(() => [
                                        _createTextVNode(" " + _toDisplayString(parseHistory(record.modify_history).length) + " 条 ", 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["disabled", "onClick"]))
                                  : (column.key === 'end_date')
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                                        (getEndDateColor(record.end_date) === 1)
                                          ? (_openBlock(), _createBlock(_component_a_tooltip, {
                                              key: 0,
                                              title: '到期: ' + record.end_date
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_a_tag, { color: "green" }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_unref(ClockCircleOutlined)),
                                                    _createTextVNode(" " + _toDisplayString(record.end_date), 1)
                                                  ]),
                                                  _: 2
                                                }, 1024)
                                              ]),
                                              _: 2
                                            }, 1032, ["title"]))
                                          : (getEndDateColor(record.end_date) === 2)
                                            ? (_openBlock(), _createBlock(_component_a_tooltip, {
                                                key: 1,
                                                title: '即将到期! 剩余3天内'
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_a_tag, { color: "gold" }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_unref(WarningOutlined)),
                                                      _createTextVNode(" " + _toDisplayString(record.end_date), 1)
                                                    ]),
                                                    _: 2
                                                  }, 1024)
                                                ]),
                                                _: 2
                                              }, 1024))
                                            : (_openBlock(), _createBlock(_component_a_tooltip, {
                                                key: 2,
                                                title: '已过期，建议尽快续费或删除'
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_a_tag, { color: "red" }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_unref(CloseCircleOutlined)),
                                                      _createTextVNode(" " + _toDisplayString(record.end_date), 1)
                                                    ]),
                                                    _: 2
                                                  }, 1024)
                                                ]),
                                                _: 2
                                              }, 1024))
                                      ], 64))
                                    : (column.key === 'remark')
                                      ? (_openBlock(), _createBlock(_component_a_input, {
                                          key: 5,
                                          value: record.remark,
                                          "onUpdate:value": ($event: any) => ((record.remark) = $event),
                                          size: "small",
                                          onFocus: ($event: any) => (cacheOrigin(record, 'remark')),
                                          onBlur: ($event: any) => (updateRemarkClick(record)),
                                          placeholder: "备注"
                                        }, null, 8, ["value", "onUpdate:value", "onFocus", "onBlur"]))
                                      : (column.key === 'action')
                                        ? (_openBlock(), _createBlock(_component_a_space, {
                                            key: 6,
                                            size: "small"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_a_button, {
                                                type: "link",
                                                size: "small",
                                                onClick: ($event: any) => (renewAuthDialog(record.empower_id, record.includes_id, record.version))
                                              }, {
                                                icon: _withCtx(() => [
                                                  _createVNode(_unref(ReloadOutlined))
                                                ]),
                                                default: _withCtx(() => [
                                                  _createTextVNode("续费 ")
                                                ]),
                                                _: 2
                                              }, 1032, ["onClick"]),
                                              (getEndDateColor(record.end_date) === 3 || record.is_free == 1)
                                                ? (_openBlock(), _createBlock(_component_a_dropdown, { key: 0 }, {
                                                    overlay: _withCtx(() => [
                                                      _createVNode(_component_a_menu, null, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_a_menu_item, {
                                                            key: "delete",
                                                            danger: "",
                                                            onClick: ($event: any) => (deleteAuthDialog(record.empower_id))
                                                          }, {
                                                            default: _withCtx(() => [
                                                              _createVNode(_unref(DeleteOutlined)),
                                                              _createTextVNode(" 删除授权 ")
                                                            ]),
                                                            _: 2
                                                          }, 1032, ["onClick"])
                                                        ]),
                                                        _: 2
                                                      }, 1024)
                                                    ]),
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_a_button, {
                                                        type: "link",
                                                        size: "small"
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createTextVNode(" 更多 "),
                                                          _createVNode(_unref(DownOutlined))
                                                        ]),
                                                        _: 1
                                                      })
                                                    ]),
                                                    _: 2
                                                  }, 1024))
                                                : _createCommentVNode("", true)
                                            ]),
                                            _: 2
                                          }, 1024))
                                        : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["data-source", "loading"]),
                      (_unref(empower_data) && _unref(empower_data).length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(empower_data), (record) => {
                              return (_openBlock(), _createBlock(_component_a_card, {
                                key: record.empower_id,
                                class: _normalizeClass(["auth-mobile-card", getEmpowerRowClass(record)]),
                                bordered: false
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_37, [
                                    _createElementVNode("div", _hoisted_38, [
                                      _createVNode(_unref(AppstoreOutlined), { style: {"color":"#1677ff","margin-right":"6px"} }),
                                      _createTextVNode(" " + _toDisplayString(record.includes_name) + " ", 1),
                                      _createVNode(_component_a_tag, {
                                        color: "blue",
                                        style: {"margin-left":"6px"}
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode("v" + _toDisplayString(record.version_name), 1)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    (getEndDateColor(record.end_date) === 1)
                                      ? (_openBlock(), _createBlock(_component_a_tag, {
                                          key: 0,
                                          color: "green"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_unref(ClockCircleOutlined)),
                                            _createTextVNode(" 正常 ")
                                          ]),
                                          _: 1
                                        }))
                                      : (getEndDateColor(record.end_date) === 2)
                                        ? (_openBlock(), _createBlock(_component_a_tag, {
                                            key: 1,
                                            color: "gold"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_unref(WarningOutlined)),
                                              _createTextVNode(" 即将到期 ")
                                            ]),
                                            _: 1
                                          }))
                                        : (_openBlock(), _createBlock(_component_a_tag, {
                                            key: 2,
                                            color: "red"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_unref(CloseCircleOutlined)),
                                              _createTextVNode(" 已过期 ")
                                            ]),
                                            _: 1
                                          }))
                                  ]),
                                  _createElementVNode("div", _hoisted_39, [
                                    _createElementVNode("div", _hoisted_40, [
                                      _hoisted_41,
                                      _createElementVNode("span", _hoisted_42, _toDisplayString(record.includes_id), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_43, [
                                      _hoisted_44,
                                      _createVNode(_component_a_input, {
                                        value: record.empower_host,
                                        "onUpdate:value": ($event: any) => ((record.empower_host) = $event),
                                        size: "small",
                                        onFocus: ($event: any) => (cacheOrigin(record, 'host')),
                                        onBlur: ($event: any) => (updateHostClick(record)),
                                        placeholder: "域名/IP",
                                        style: {"flex":"1"}
                                      }, null, 8, ["value", "onUpdate:value", "onFocus", "onBlur"])
                                    ]),
                                    _createElementVNode("div", _hoisted_45, [
                                      _hoisted_46,
                                      _createElementVNode("span", _hoisted_47, _toDisplayString(record.end_date), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_48, [
                                      _hoisted_49,
                                      _createElementVNode("span", {
                                        class: _normalizeClass(["modify-count", { 'modify-count-zero': !record.modify_count }])
                                      }, _toDisplayString(record.modify_count || 0) + " 次 ", 3),
                                      _createVNode(_component_a_button, {
                                        size: "small",
                                        type: "link",
                                        disabled: !record.modify_history,
                                        onClick: ($event: any) => (openHistoryDialog(record))
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(HistoryOutlined)),
                                          _createTextVNode(" " + _toDisplayString(parseHistory(record.modify_history).length) + " 条 ", 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["disabled", "onClick"])
                                    ]),
                                    _createElementVNode("div", _hoisted_50, [
                                      _hoisted_51,
                                      _createVNode(_component_a_input, {
                                        value: record.remark,
                                        "onUpdate:value": ($event: any) => ((record.remark) = $event),
                                        size: "small",
                                        onFocus: ($event: any) => (cacheOrigin(record, 'remark')),
                                        onBlur: ($event: any) => (updateRemarkClick(record)),
                                        placeholder: "点击添加备注",
                                        style: {"flex":"1"}
                                      }, null, 8, ["value", "onUpdate:value", "onFocus", "onBlur"])
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_52, [
                                    _createVNode(_component_a_button, {
                                      type: "primary",
                                      size: "small",
                                      onClick: ($event: any) => (renewAuthDialog(record.empower_id, record.includes_id, record.version))
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(ReloadOutlined)),
                                        _createTextVNode(" 续费 ")
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"]),
                                    (getEndDateColor(record.end_date) === 3 || record.is_free == 1)
                                      ? (_openBlock(), _createBlock(_component_a_button, {
                                          key: 0,
                                          size: "small",
                                          onClick: ($event: any) => (deleteAuthDialog(record.empower_id))
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_unref(DeleteOutlined)),
                                            _createTextVNode(" 删除 ")
                                          ]),
                                          _: 2
                                        }, 1032, ["onClick"]))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                _: 2
                              }, 1032, ["class"]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true),
                      ((!_unref(empower_data) || _unref(empower_data).length === 0) && !empower_Conf.value.disabled)
                        ? (_openBlock(), _createBlock(_component_a_empty, {
                            key: 1,
                            class: "auth-mobile-empty",
                            description: "暂无授权数据"
                          }))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_53, [
                        _createVNode(_component_a_pagination, {
                          current: empower_Conf.value.currentPage,
                          "onUpdate:current": _cache[6] || (_cache[6] = ($event: any) => ((empower_Conf.value.currentPage) = $event)),
                          "page-size": empower_Conf.value.pageSize,
                          "onUpdate:pageSize": _cache[7] || (_cache[7] = ($event: any) => ((empower_Conf.value.pageSize) = $event)),
                          "page-size-options": [10, 25, 50],
                          disabled: empower_Conf.value.disabled,
                          "show-size-changer": "",
                          "show-quick-jumper": "",
                          "show-total": (total) => `共 ${total} 条记录`,
                          total: empower_Conf.value.total,
                          onChange: pageChange
                        }, null, 8, ["current", "page-size", "disabled", "show-total", "total"])
                      ])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_a_modal, {
      "mask-closable": false,
      open: _unref(centerDialog).isShow,
      "onUpdate:open": _cache[10] || (_cache[10] = ($event: any) => ((_unref(centerDialog).isShow) = $event)),
      title: _unref(centerDialog).title,
      width: 560,
      centered: ""
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_a_button, {
          onClick: _cache[8] || (_cache[8] = ($event: any) => (_unref(centerDialog).isShow = false))
        }, {
          default: _withCtx(() => [
            _createTextVNode("取消")
          ]),
          _: 1
        }),
        _createVNode(_component_a_button, {
          type: "primary",
          onClick: _cache[9] || (_cache[9] = ($event: any) => (centerDialogClick(_unref(centerDialog).clickBind)))
        }, {
          default: _withCtx(() => [
            _createTextVNode("确认")
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_alert, {
          type: "warning",
          "show-icon": "",
          message: _unref(centerDialog).content
        }, null, 8, ["message"])
      ]),
      _: 1
    }, 8, ["open", "title"]),
    _createVNode(_component_a_modal, {
      "mask-closable": true,
      open: _unref(historyDialog).isShow,
      "onUpdate:open": _cache[12] || (_cache[12] = ($event: any) => ((_unref(historyDialog).isShow) = $event)),
      title: "授权修改历史",
      width: 720,
      centered: ""
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_a_button, {
          type: "primary",
          onClick: _cache[11] || (_cache[11] = ($event: any) => (_unref(historyDialog).isShow = false))
        }, {
          default: _withCtx(() => [
            _createTextVNode("关闭")
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_alert, {
          type: "info",
          "show-icon": "",
          class: "history-alert"
        }, {
          message: _withCtx(() => [
            _createTextVNode(" 1.每月可免费修改授权次数有限，2.每个授权累计的免费修改次数有限，超出后可付费修改（从余额扣除） ")
          ]),
          _: 1
        }),
        _createVNode(_component_a_table, {
          "data-source": _unref(historyDialog).list,
          pagination: false,
          "row-key": "time",
          size: "small"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_table_column, {
              type: "index",
              label: "序号",
              width: "60",
              align: "center"
            }),
            _createVNode(_component_a_table_column, {
              "data-index": "old_host",
              label: "修改前",
              width: 160
            }, {
              bodyCell: _withCtx(({ record }) => [
                _createElementVNode("span", _hoisted_54, _toDisplayString(record.old_host), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_table_column, {
              "data-index": "new_host",
              label: "修改后",
              width: 160
            }, {
              bodyCell: _withCtx(({ record }) => [
                _createElementVNode("span", _hoisted_55, _toDisplayString(record.new_host), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_table_column, {
              label: "类型",
              width: "80",
              align: "center"
            }, {
              bodyCell: _withCtx(({ record }) => [
                _createVNode(_component_a_tag, {
                  color: record.is_paid == 1 ? 'blue' : 'default'
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(record.is_paid == 1 ? '付费' : '免费'), 1)
                  ]),
                  _: 2
                }, 1032, ["color"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_table_column, {
              "data-index": "time",
              label: "修改时间",
              width: "180",
              align: "center"
            })
          ]),
          _: 1
        }, 8, ["data-source"]),
        (_unref(historyDialog).list.length === 0)
          ? (_openBlock(), _createBlock(_component_a_empty, {
              key: 0,
              description: "暂无历史修改记录"
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["open"]),
    _createVNode(_component_a_modal, {
      "mask-closable": false,
      open: _unref(trendsDialog).dialogVisible,
      "onUpdate:open": _cache[16] || (_cache[16] = ($event: any) => ((_unref(trendsDialog).dialogVisible) = $event)),
      title: "选择等级",
      width: 560,
      centered: ""
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_a_button, {
          onClick: _cache[14] || (_cache[14] = ($event: any) => (_unref(trendsDialog).dialogVisible = false))
        }, {
          default: _withCtx(() => [
            _createTextVNode("关闭")
          ]),
          _: 1
        }),
        _createVNode(_component_a_button, {
          type: "primary",
          onClick: _cache[15] || (_cache[15] = ($event: any) => (centerDialogClick('gradeUp')))
        }, {
          default: _withCtx(() => [
            _createTextVNode("确认升级")
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_form, { layout: "vertical" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, { label: "升级等级" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  value: select_option.value,
                  "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((select_option).value = $event)),
                  placeholder: "请选择需要升级的等级"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(grade_Option), (item) => {
                      return (_openBlock(), _createBlock(_component_a_select_option, {
                        key: item.grade_id,
                        value: item.grade_id
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.name +
            '---'
            + item.price_diff + '元'), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 128)),
                    (_unref(grade_Option).length == 0)
                      ? (_openBlock(), _createBlock(_component_a_select_option, {
                          key: 0,
                          disabled: ""
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("您已经是最高等级了")
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["open"]),
    _createVNode(_component_a_modal, {
      "mask-closable": false,
      open: _unref(addEmpower_dialog).dialogVisible,
      "onUpdate:open": _cache[27] || (_cache[27] = ($event: any) => ((_unref(addEmpower_dialog).dialogVisible) = $event)),
      title: _unref(addEmpower_dialog).title,
      centered: "",
      width: 720
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_a_button, {
          onClick: _cache[24] || (_cache[24] = ($event: any) => (_unref(addEmpower_dialog).dialogVisible = false))
        }, {
          default: _withCtx(() => [
            _createTextVNode("关闭")
          ]),
          _: 1
        }),
        _withDirectives(_createVNode(_component_a_button, {
          type: "primary",
          onClick: _cache[25] || (_cache[25] = ($event: any) => (openDialog('消息', '您确定要添加此授权吗？您需要支付' + getTimePrice.value + '元', true, 'addEmpower')))
        }, {
          default: _withCtx(() => [
            _createTextVNode(" 添加授权 ")
          ]),
          _: 1
        }, 512), [
          [_vShow, !_unref(appConf).isRenew]
        ]),
        _withDirectives(_createVNode(_component_a_button, {
          type: "primary",
          onClick: _cache[26] || (_cache[26] = ($event: any) => (openDialog('消息', '您确定要续费此授权吗？您需要支付' + getTimePrice.value + '元', true, 'renewEmpower')))
        }, {
          default: _withCtx(() => [
            _createTextVNode(" 续费授权 ")
          ]),
          _: 1
        }, 512), [
          [_vShow, _unref(appConf).isRenew]
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_form, { layout: "vertical" }, {
          default: _withCtx(() => [
            _withDirectives(_createVNode(_component_a_form_item, { label: "授权插件" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  value: _unref(includes_data).select_option,
                  "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => ((_unref(includes_data).select_option) = $event)),
                  onChange: getPluginVersions,
                  placeholder: "请选择插件"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(includes_data).includes_list, (item) => {
                      return (_openBlock(), _createBlock(_component_a_select_option, {
                        key: item.id,
                        value: item.id
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.id +
            '---' + item.platform + '---' + item.name), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 128)),
                    (_unref(includes_data).includes_list.length == 0)
                      ? (_openBlock(), _createBlock(_component_a_select_option, {
                          key: 0,
                          disabled: ""
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("--暂无插件/您不是任何插件的代理--")
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }, 512), [
              [_vShow, !_unref(appConf).isRenew]
            ]),
            _withDirectives(_createVNode(_component_a_form_item, { label: "功能版本" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  value: _unref(version_data).select_option,
                  "onUpdate:value": _cache[18] || (_cache[18] = ($event: any) => ((_unref(version_data).select_option) = $event)),
                  onChange: onVersionChange,
                  placeholder: "请选择功能版本",
                  disabled: _unref(version_data).version_list.length === 0
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(version_data).version_list, (item) => {
                      return (_openBlock(), _createBlock(_component_a_select_option, {
                        key: item.version,
                        value: item.version
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.version + '--' + item.versionName), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 128)),
                    (_unref(version_data).version_list.length === 0 && _unref(includes_data).select_option)
                      ? (_openBlock(), _createBlock(_component_a_select_option, {
                          key: 0,
                          disabled: ""
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("--该插件无版本信息--")
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["value", "disabled"])
              ]),
              _: 1
            }, 512), [
              [_vShow, !_unref(appConf).isRenew]
            ]),
            _createVNode(_component_a_form_item, { label: "授权时长单位" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  value: _unref(time_meal_data).select_option,
                  "onUpdate:value": _cache[19] || (_cache[19] = ($event: any) => ((_unref(time_meal_data).select_option) = $event)),
                  onChange: _cache[20] || (_cache[20] = ($event: any) => (setTimeMeal(_unref(time_meal_data).select_option))),
                  placeholder: "请选择时长单位",
                  disabled: _unref(time_meal_data).time_meal_list.length === 0
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(time_meal_data).time_meal_list, (item) => {
                      return (_openBlock(), _createBlock(_component_a_select_option, {
                        key: item.meal_id,
                        value: item.meal_id
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.time_unit + '---每' + item.time_unit + ' ' + item.price + '元'), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["value", "disabled"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "授权时长" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input_number, {
                  value: _unref(time_meal_data).num,
                  "onUpdate:value": _cache[21] || (_cache[21] = ($event: any) => ((_unref(time_meal_data).num) = $event)),
                  min: _unref(time_meal_data).min,
                  max: _unref(time_meal_data).max
                }, null, 8, ["value", "min", "max"]),
                (_unref(time_meal_data).unit != '')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_56, _toDisplayString(_unref(time_meal_data).unit), 1))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _withDirectives(_createVNode(_component_a_form_item, { label: "绑定邮箱" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _unref(addEmpower_dialog).user_email,
                  "onUpdate:value": _cache[22] || (_cache[22] = ($event: any) => ((_unref(addEmpower_dialog).user_email) = $event)),
                  placeholder: "若是普通用户则填写当前绑定邮箱"
                }, null, 8, ["value"])
              ]),
              _: 1
            }, 512), [
              [_vShow, !_unref(appConf).isRenew]
            ]),
            _withDirectives(_createVNode(_component_a_form_item, { label: "授权字段(域名/ip等)" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _unref(addEmpower_dialog).host,
                  "onUpdate:value": _cache[23] || (_cache[23] = ($event: any) => ((_unref(addEmpower_dialog).host) = $event)),
                  placeholder: "请输入域名或IP"
                }, null, 8, ["value"])
              ]),
              _: 1
            }, 512), [
              [_vShow, !_unref(appConf).isRenew]
            ]),
            (_unref(time_meal_data).unit != '')
              ? (_openBlock(), _createBlock(_component_a_alert, {
                  key: 0,
                  class: "empower-total",
                  "show-icon": "",
                  type: "info"
                }, {
                  message: _withCtx(() => [
                    _createTextVNode("总计: "),
                    _createElementVNode("strong", _hoisted_57, _toDisplayString(getTimePrice.value), 1),
                    _createTextVNode(" 元")
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["open", "title"]),
    _createVNode(_component_a_modal, {
      open: _unref(balanceRechargeDialog).isShow,
      "onUpdate:open": _cache[32] || (_cache[32] = ($event: any) => ((_unref(balanceRechargeDialog).isShow) = $event)),
      title: "账户充值",
      width: 560,
      centered: "",
      "mask-closable": true
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_a_button, {
          onClick: _cache[30] || (_cache[30] = ($event: any) => (_unref(balanceRechargeDialog).isShow = false))
        }, {
          default: _withCtx(() => [
            _createTextVNode("取消")
          ]),
          _: 1
        }),
        _createVNode(_component_a_button, {
          type: "primary",
          onClick: _cache[31] || (_cache[31] = ($event: any) => (toRecharge()))
        }, {
          default: _withCtx(() => [
            _createTextVNode("确认充值")
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_form, { layout: "vertical" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, { label: "充值金额" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input_number, {
                  min: _unref(balanceRechargeDialog).checkType.min,
                  max: _unref(balanceRechargeDialog).checkType.max,
                  value: _unref(balanceRechargeDialog).money,
                  "onUpdate:value": _cache[28] || (_cache[28] = ($event: any) => ((_unref(balanceRechargeDialog).money) = $event)),
                  style: {"width":"100%"},
                  precision: 2,
                  placeholder: '单笔充值范围:' + _unref(balanceRechargeDialog).checkType.min + '--' + _unref(balanceRechargeDialog).checkType.max
                }, null, 8, ["min", "max", "value", "placeholder"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "支付方式" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  value: _unref(balanceRechargeDialog).type,
                  "onUpdate:value": _cache[29] || (_cache[29] = ($event: any) => ((_unref(balanceRechargeDialog).type) = $event)),
                  placeholder: "请选择支付方式",
                  onChange: payTypeChange
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(balanceRechargeDialog).types, (item) => {
                      return (_openBlock(), _createBlock(_component_a_select_option, {
                        key: item.type,
                        value: item.type
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.name
            +
            '(手续费' + item.fee + ')'), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["open"])
  ], 64))
}
}

})